import { __decorate } from "tslib";
import { ContentInfo } from "@peculiar/asn1-cms";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
let TimeStampToken = class TimeStampToken extends ContentInfo {
};
TimeStampToken = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], TimeStampToken);
export { TimeStampToken };
